class AgeGate extends HTMLElement {
  constructor() {
    super();
    this.storageKey = this.dataset.storageKey || 'ageGateVerified';
    this.minAge = parseInt(this.dataset.minAge, 10) || 18;
    this.rememberDays = parseInt(this.dataset.rememberDays, 10) || 30;

    this.card = this.querySelector('.age-gate__card');
    this.form = this.querySelector('.age-gate__form');
    this.denied = this.querySelector('.age-gate__denied');
    this.select = this.querySelector('.age-gate__select');
    this.submit = this.querySelector('.age-gate__submit');
    this.error = this.querySelector('.age-gate__error');
  }

  connectedCallback() {
    if (this.isVerified()) {
      this.dismiss(false);
      return;
    }

    this.show();

    if (this.submit) this.submit.addEventListener('click', this.onSubmit.bind(this));
    if (this.select) this.select.addEventListener('change', this.clearError.bind(this));
  }

  isVerified() {
    try {
      const raw = localStorage.getItem(this.storageKey);
      if (!raw) return false;
      const data = JSON.parse(raw);
      return !!(data && data.exp && data.exp > Date.now());
    } catch (e) {
      return false;
    }
  }

  persist() {
    try {
      const exp = Date.now() + this.rememberDays * 24 * 60 * 60 * 1000;
      localStorage.setItem(this.storageKey, JSON.stringify({ exp: exp }));
    } catch (e) {
      // Storage unavailable (e.g. private mode): the gate simply reappears next load.
    }
  }

  show() {
    document.documentElement.classList.remove('age-gate-passed');
    document.documentElement.classList.add('age-gate-active');

    if (typeof trapFocus === 'function') {
      trapFocus(this.card || this, this.select);
    } else if (this.select) {
      this.select.focus();
    }
  }

  dismiss(untrap = true) {
    document.documentElement.classList.remove('age-gate-active');
    document.documentElement.classList.add('age-gate-passed');

    if (untrap && typeof removeTrapFocus === 'function') removeTrapFocus();
  }

  onSubmit(event) {
    event.preventDefault();

    const year = this.select ? parseInt(this.select.value, 10) : NaN;

    if (!year || Number.isNaN(year)) {
      this.showError();
      return;
    }

    const age = new Date().getFullYear() - year;

    if (age >= this.minAge) {
      this.persist();
      this.dismiss();
    } else {
      this.reject();
    }
  }

  reject() {
    if (this.form) this.form.hidden = true;
    if (this.denied) {
      this.denied.hidden = false;
      this.denied.setAttribute('role', 'alert');
      this.denied.setAttribute('tabindex', '-1');
      this.denied.focus();
    }
  }

  showError() {
    if (this.error) this.error.hidden = false;
    if (this.select) this.select.setAttribute('aria-invalid', 'true');
  }

  clearError() {
    if (this.error) this.error.hidden = true;
    if (this.select) this.select.removeAttribute('aria-invalid');
  }
}

customElements.define('age-gate', AgeGate);
